import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { Button, ValidationError } from '../../../../../components';
import { showMessageBox } from '../../../../../components/modals';
import { onSuccess } from '../../../../../utils/errors';
import Sellable from '../../../store/sellable/Sellable';

export default observer(function SaveSellableButton({
  sellable,
  sellableName,
}: {
  sellable: Sellable;
  sellableName: string;
}) {
  const navigate = useNavigate();

  return (
    <Button
      disabled={!sellable.isChanged || !sellable.isValid}
      disabledTooltip={sellable.allErrorsAsStrings}
      icon="save"
      onClick={() => saveSellable(sellable, navigate)}
      type="primary"
    >
      Save {sellableName}
    </Button>
  );
});

async function saveSellable(
  sellable: Sellable,
  navigate: (route: string) => void,
) {
  const errors = sellable.validate();

  if (errors.length > 0) {
    await showMessageBox({
      title: 'Fill the form',
      content: <ValidationError error={errors} />,
    });
    return;
  }

  if (!sellable.isNew) {
    await sellable.save();
    onSuccess(`${sellable.displayName} successfully saved`);
    return;
  }

  const buttonId = await showMessageBox({
    title: 'Are you sure?',
    content: (
      <>
        This action <b>cannot</b> be undone. After creating, some options like
        SKU and Price cannot be changed.
      </>
    ),
    buttons: [
      { id: 'save', title: 'Save' },
      { id: 'cancel', title: 'Cancel' },
    ],
  });

  if (buttonId === 'save') {
    await sellable.save();
    const { id } = sellable;
    navigate(sellable.type === 'bundle' ? `/bundles/${id}` : `/products/${id}`);
    onSuccess(`${sellable.displayName} successfully saved`);
  }
}
